import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import textUtils from "@mnjsplatform/data/lib/utils/textUtils";
import i18next from "i18next";

class SubOfficialDocuments extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isDataReady: false
        }
    }

    componentDidMount() {
        this.setState({isDataReady: false}, this.initialize);
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.listSubForPO.reset());
            await this.props.dispatch(this.props.listSubForPO.execute({}, {withParams: true}));
            /*
            await this.props.dispatch(this.props.dataItem_JobDesc.initialize({}, {refresh: false}));
            await this.props.dispatch(this.props.dataItem_JobDescArc.initialize({}, {refresh: false}));
            */
            await this.props.dispatch(this.props.dataItem_JobDesc.execute());
            await this.props.dispatch(this.props.dataItem_JobDescArc.execute());
            await this.applyParams();
        } catch (e) {
            console.error(e);
        } finally {
            this.setState({isDataReady: true});
        }
    }

    renderParam = (h) => {
        return (<>
                <div className="row mb-2">
                    <div className="col-md-4">
                        {/*Количество уровней подчиненности (<span style={{color: "red"}}>не более 5 уровней</span>):*/}
                        {h.lbl("NumSub")}
                    </div>
                    <div className="col-md-1">
                        {h.ed("NumSub")}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-12">
                        {h.ed("AdmStructName")}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-4">
                        {i18next.t("SubordinateSearch")}:
                    </div>
                    <div className="col-md-8" style={{height: "32px"}}>
                        <SearchBar dataItem={this.props.listSubForPO} autoFields={false} fieldSet={['TFIO']}/>
                    </div>
                </div>
            </>);
    };

    renderCellLink = (cellParams) => {
        if (cellParams.fieldInfo.Name === "ListUrl") {
            return (<div>
                <label>
                    <a href={cellParams.row.ListUrl}
                       rel="noopener noreferrer">{cellParams.row.ListUrl}</a>
                </label>
            </div>);
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }
    applyParams = async () => {
        await this.props.dispatch(this.props.dataItem_JobDesc.applyParams(this.props.listSubForPOParams));
        await this.props.dispatch(this.props.dataItem_JobDescArc.applyParams(this.props.listSubForPOParams));
    }

    render() {
        if (!this.state.isDataReady) return null;
        let cnt = this.props.listSubForPO.rowsCount();
        let gridTitleText = i18next.t("SubOfficialDocuments_GridTitle", {people_count: textUtils.pluralize_i18next(cnt, "peopleCountPostfix")});

        return (<>
                <PlaceholderWrapper placeholderId="10"
                                    title={<><i className='fa fa-filter'/> {i18next.t("OfficialDocuments")}</>}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    <ComplexParam dataItem={this.props.listSubForPOParams}
                                  readOnly={false}
                                  showSearchBar={false}
                                  showApplyButton={false}
                                  autoApplyParams={true}
                                  rootPath="/"
                                  parentDataItem={this.props.listSubForPO}
                                  renderParams={this.renderParam}
                                  afterApplyParams={this.applyParams}
                    />
                </PlaceholderWrapper>
                <PlaceholderWrapper placeholderId="20"
                                    title={<><i className='fa fa-table'/> {gridTitleText}</>}
                                    staticTitle={i18next.t("SubOfficialDocuments_GridTitle")}
                                    showSplitterLine={false}
                                    canCollapse={true}
                > <GridView dataItem={this.props.listSubForPO} renderCellEx={this.renderCellLink}/>
                </PlaceholderWrapper>
                <PlaceholderWrapper placeholderId="30"
                                    title={<><i
                                        className='fa fa-table'/> {i18next.t("Department_Job_Descriptions")}</>}
                                    showSplitterLine={false}
                                    canCollapse={true}
                >
                    <GridView dataItem={this.props.dataItem_JobDesc} renderCellEx={this.renderCellLink}/>
                </PlaceholderWrapper>
                <PlaceholderWrapper placeholderId="40"
                                    title={<><i
                                        className='fa fa-table'/> {i18next.t("Department_Job_Descriptions_Archive")}</>}
                                    showSplitterLine={false}
                                    canCollapse={true}
                                    collapsed={true}
                >
                    <GridView dataItem={this.props.dataItem_JobDescArc} renderCellEx={this.renderCellLink}/>
                </PlaceholderWrapper>
            </>);
    }
}

SubOfficialDocuments.propTypes = {
    dispatch: PropTypes.func.isRequired,
    listSubForPO: PropTypes.object,
    listSubForPOParams: PropTypes.object,
    dataItem_JobDesc: PropTypes.object,
    dataItem_JobDescArc: PropTypes.object
}

SubOfficialDocuments.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        listSubForPO: state.subOfficialDocumentsState.OfficialDocuments_ListSubForPO,
        listSubForPOParams: state.subOfficialDocumentsState.OfficialDocuments_ListSubForPOParams,
        dataItem_JobDesc: state.subOfficialDocumentsState.PersJobDescExam_ListASForSubForNewPO,
        dataItem_JobDescArc: state.subOfficialDocumentsState.PersJobDescExam_ListASForSubForNewArcPO
    }
}

export default connect(mapStateToProps)(SubOfficialDocuments);